import { standardGetQuery } from "./apiUtils.js";
import { userOnPath } from "../shared/pageUtils.js";

import * as Constants from "../../config/constants/Constants.js";

export const statisticsQueryPath = (path, libraryId) => {
    if (libraryId === null || libraryId === undefined || libraryId === "") return path;
    return `${path}?library_id=${encodeURIComponent(libraryId)}`;
};

const statisticsPath = (path, props) => statisticsQueryPath(path, props.backend.statisticsLibraryIdRef?.current);

/**
 * Fetch the status info about external resources.
 */
export const queryProgramStatus = (props) => {
    standardGetQuery(props, Constants.API_PROGRAM_STATUS, (response) => {
        props.backend.setProgramStatus(response.body);
    });
};

/**
 * Function for querying statistics about resources.
 */
const applyStatistics = (props, path, response, resolvedPath, apply) => {
    if (resolvedPath !== statisticsPath(path, props)) return;
    apply(response.body);
};

export const queryResourceStatistics = (props, options = {}) => {
    standardGetQuery(
        props,
        () => statisticsPath(Constants.API_STATISTICS_RESOURCES, props),
        (response, resolvedPath) => {
            applyStatistics(props, Constants.API_STATISTICS_RESOURCES, response, resolvedPath, props.backend.setResourceStatistics);
        },
        {
            interval: options.once ? undefined : 60,
            condition: () => userOnPath(["/database/statistics"])
        }
    );
};

/**
 * Function for querying statistics about transcripts.
 */
export const queryTranscriptStatistics = (props, options = {}) => {
    standardGetQuery(
        props,
        () => statisticsPath(Constants.API_STATISTICS_TRANSCRIPTS, props),
        (response, resolvedPath) => {
            applyStatistics(props, Constants.API_STATISTICS_TRANSCRIPTS, response, resolvedPath, props.backend.setTranscriptStatistics);
        },
        {
            interval: options.once ? undefined : 50,
            condition: () => userOnPath(["/database/statistics"])
        }
    );
};

/**
 * Function for querying statistics about authors.
 */
export const queryAuthorStatistics = (props, options = {}) => {
    standardGetQuery(
        props,
        () => statisticsPath(Constants.API_STATISTICS_AUTHORS, props),
        (response, resolvedPath) => {
            applyStatistics(props, Constants.API_STATISTICS_AUTHORS, response, resolvedPath, props.backend.setAuthorStatistics);
        },
        {
            interval: options.once ? undefined : 55,
            condition: () => userOnPath(["/database/statistics"])
        }
    );
};

/**
 * Function for querying statistics about highlights.
 */
export const queryHighlightStatistics = (props, options = {}) => {
    standardGetQuery(
        props,
        () => statisticsPath(Constants.API_STATISTICS_HIGHLIGHTS, props),
        (response, resolvedPath) => {
            applyStatistics(props, Constants.API_STATISTICS_HIGHLIGHTS, response, resolvedPath, props.backend.setHighlightStatistics);
        },
        {
            interval: options.once ? undefined : 65,
            condition: () => userOnPath(["/database/statistics"])
        }
    );
};
